import type { UserContactChannel } from '@/shared/types/global.types'

export const CONTACT_CHANNELS: readonly UserContactChannel[] = [
  'whatsapp',
  'sms',
  'email',
  'phone',
]

export const ONBOARDING_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
} as const

export const ONBOARDING_MESSAGE = {
  COMPLETE_ONBOARDING: 'ob_completed_onboarding',
  SHOW_ONBOARDING_BUTTON_CLOSE: 'ob_show_onboarding_button_close',
} as const

const WHO_IS_COVERED = 'onboarding.renters.form.whoIsCovered'

export const PET_TYPE_OPTIONS = [
  { value: 'Dog', label: `${WHO_IS_COVERED}.petTypeOptions.dog` },
  { value: 'Cat', label: `${WHO_IS_COVERED}.petTypeOptions.cat` },
]

export const PET_AGE_OPTIONS = [
  { value: '120', label: `${WHO_IS_COVERED}.petAgeOptions.months2To6` },
  { value: '273', label: `${WHO_IS_COVERED}.petAgeOptions.months6To12` },
  { value: '547', label: `${WHO_IS_COVERED}.petAgeOptions.year1` },
  { value: '913', label: `${WHO_IS_COVERED}.petAgeOptions.years2` },
  { value: '1278', label: `${WHO_IS_COVERED}.petAgeOptions.years3` },
  { value: '1643', label: `${WHO_IS_COVERED}.petAgeOptions.years4` },
  { value: '2008', label: `${WHO_IS_COVERED}.petAgeOptions.years5` },
  { value: '2373', label: `${WHO_IS_COVERED}.petAgeOptions.years6` },
  { value: '2738', label: `${WHO_IS_COVERED}.petAgeOptions.years7` },
  { value: '3103', label: `${WHO_IS_COVERED}.petAgeOptions.years8` },
  { value: '3468', label: `${WHO_IS_COVERED}.petAgeOptions.years9` },
  { value: '3833', label: `${WHO_IS_COVERED}.petAgeOptions.years10` },
  { value: '4198', label: `${WHO_IS_COVERED}.petAgeOptions.years11` },
  { value: '4563', label: `${WHO_IS_COVERED}.petAgeOptions.years12` },
  { value: '4928', label: `${WHO_IS_COVERED}.petAgeOptions.years13` },
  { value: '5293', label: `${WHO_IS_COVERED}.petAgeOptions.years14` },
]
